namespace appn.views.provider.upgradeFromGF {

    export function init(): void {
        $('#Proceed').hide();
        addEvents();
    }

    function addEvents() {
        $('#Accept').change(function(event) {
            if ($(this).is(':checked'))
                $('#Proceed').show();
            else
                $('#Proceed').hide();
        });

        $('#UpgradeBtn').click(function(event) {
            event.preventDefault();

            const submitType = (this as any).value;

            appn.dialog.confirm({
                modalColor: 'modal-info',
                title: T('Upgrade Billing Plan'),
                message: T('Are you sure you want to upgrade?'),
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                callback: function(result: any) {
                    if (result) {
                        $('form').append('<input type="hidden" name="submitType" value="' + submitType + '" />');
                        $('form').submit();
                    } else
                        event.stopImmediatePropagation();
                }
            });
        });
    }
}
